{
  "baby": "Baby",
  "ring": {
    "woke": "Woke {{time}}",
    "asleep": "Asleep {{time}}",
    "awakeSince": "Awake since {{time}}",
    "bed": "Bed ~{{time}}",
    "nap": "Nap ~{{time}}",
    "wake": "Wake ~{{time}}"
  },
  "timer": {
    "bedtime": "Bedtime",
    "napN": "Nap {{n}}",
    "nextNap": "Next nap",
    "justWoke": " · just woke up",
    "awakeFor": " · awake {{time}}",
    "whatTime": "{{what}} time",
    "now": "Now",
    "plannedFor": "Planned for {{time}}{{awake}}",
    "whatIn": "{{what}} in",
    "around": "Around {{time}}{{awake}}",
    "asleepFor": "Asleep for",
    "usuallyUp": "{{sleep}} · usually up around {{time}}",
    "wakesIn": "Wakes in",
    "justFellAsleep": "{{sleep}} · just fell asleep",
    "asleepTime": "{{sleep}} · asleep {{time}}",
    "nightAwake": "Awake at night",
    "since": "Since {{time}}",
    "leftOn": "Sleep timer left on",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "started": "Started {{day}} {{time}}",
    "label": "Sleep timer",
    "none": "–",
    "noneSub": "Log a sleep and the timer starts",
    "loading": "…",
    "loadingSub": "Loading the plan",
    "night": "Night sleep",
    "napTitle": "Nap"
  },
  "toast": {
    "stepDone": "{{step}} done",
    "notSaved": "That did not save. Try again.",
    "nightStarted": "Night sleep started",
    "timerStarted": "Sleep timer started",
    "sleepSaved": "Sleep saved · {{time}}",
    "hintHidden": "Hint hidden",
    "undo": "Undo",
    "close": "Close"
  },
  "card": {
    "label": "Sleep timer",
    "staleTitle": "Forgot to stop the timer?",
    "staleSub": "Set when {{name}} woke up",
    "staleAction": "Fix time",
    "staleLabel": "Fix the sleep timer that was left on",
    "wokeTitle": "{{name}} woke up?",
    "wokeSub": "Stops the sleep timer",
    "wokeAction": "Woke up",
    "wokeLabel": "{{name}} woke up: stop the sleep timer",
    "asleepTitle": "{{name}} fell asleep?",
    "backAsleepSub": "Tap when {{name}} is back asleep",
    "asleepSub": "Starts the sleep timer",
    "backAsleep": "Back asleep",
    "startNight": "Start night",
    "startNap": "Start nap",
    "asleepLabel": "{{name}} fell asleep: start the sleep timer"
  },
  "hint": {
    "away": "Welcome back! Log a feed or a nap",
    "night": "Night feed? Log it",
    "feed": "Last feed {{time}} ago",
    "diaper": "Last diaper {{time}} ago",
    "log": "Log",
    "hide": "Hide this hint"
  },
  "sound": {
    "play": "Play {{name}}",
    "pause": "Pause {{name}}",
    "pauseShort": "Pause",
    "pills": "Sound, sound timer and cry alert",
    "change": "Sound: {{name}}. Change",
    "timer": "When the sound stops",
    "left": "left",
    "offIn": "Off in {{min}}m",
    "playsOn": "Plays on",
    "cryAlert": "Cry alert"
  },
  "routine": {
    "label": "Bedtime routine",
    "step": "Bedtime routine · {{n}} of {{total}}",
    "bedAt": "Bed at {{time}}",
    "now": "Now",
    "minutes": " · {{min}} min",
    "then": "Then {{step}}",
    "last": "Last step",
    "stepDone": "{{step}} done",
    "done": "Done",
    "allDone": "Bedtime routine · done",
    "lightsOut": "Lights out",
    "sleepWell": "Bed at {{time}} · sleep well"
  },
  "error": {
    "offline": "Offline · showing the last plan",
    "generic": "Could not refresh the plan.",
    "retry": "Retry"
  }
}
